import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InfoIcon from "@material-ui/icons/InfoOutlined";

import { saveAs } from "file-saver";

import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";
import CustomTableHead from "../components/CustomTableHead";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomPaginatorActions from "../components/CustomPaginatorActions";

import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import {
  getSorting,
  getNumberSorting,
  getFloatSorting,
} from "../components/Utils";
import { getErrorString } from "../display/ErrorStrings";
import CCRequest from "../details/CCRequest";
import ViewPdf from "../components/ViewPdf";
import ViewCCCheck from "../components/ViewCCCheck";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import PrintIcon from "@material-ui/icons/PrintOutlined";
import HistoryIcon from "@material-ui/icons/HistoryOutlined";
import ApproveIcon from "@material-ui/icons/CheckBoxOutlined";
import CCAddIcon from "@material-ui/icons/LibraryAddOutlined";

import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const columnData = [
  { id: "date", numeric: false, disablePadding: true, label: "Request Date" },
  {
    id: "requestor",
    numeric: false,
    disablePadding: true,
    label: "Requested By",
  },
  {
    id: "requestId",
    numeric: false,
    disablePadding: true,
    label: "Request ID",
  },
  {
    id: "checkNumber",
    numeric: false,
    disablePadding: true,
    label: "Check Number",
  },
  { id: "amount", numeric: false, disablePadding: true, label: "Amount" },
  { id: "payable", numeric: false, disablePadding: true, label: "Payable" },
  { id: "status", numeric: false, disablePadding: true, label: "Status" },
  { id: "voidInd", numeric: false, disablePadding: true, label: "Void Ind" },
  {
    id: "custCount",
    numeric: false,
    disablePadding: true,
    label: "Cust Count",
  },
  { id: "nosort", numeric: false, disablePadding: true, label: "More..." },
];

const columnData2 = [
  {
    id: "requestId",
    numeric: false,
    disablePadding: true,
    label: "Request ID",
  },
  { id: "serial", numeric: false, disablePadding: true, label: "Serial" },
  { id: "amount", numeric: false, disablePadding: true, label: "Amount" },
  { id: "payable", numeric: false, disablePadding: true, label: "Payee" },
  { id: "action", numeric: false, disablePadding: true, label: "Action" },
];

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  vCenterItems: {
    display: "flex",
    alignItems: "center",
  },

  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP + ACCOUNTS_TOOLBAR_HEIGHT + 10}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP + ACCOUNTS_TOOLBAR_HEIGHT}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  disabledButton: {
    backgroundColor: theme.palette.secondary.main,
    fontWeight: "bold",
  },
});

class ManageCCPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      order: "asc",
      orderBy: "",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      backendStartDate: "",
      backendEndDate: "",
      checkFrom: "",
      checkTo: "",
      amountFrom: "",
      amountTo: "",
      reportType: "request",
      radioValue: "date",
      reportStatus: "10",
      collapsedSearch: false,
      totalCount: 0,
      totalAmount: "",
      items: [],
      reply: {},
      viewPopup: false,
      viewPdf: false,
      canSearch: false,
      action: 0,
      selectedItemIndex: -1,
      selectedItem: {},
      acceptDisposition: true,
      confirmDisposition: false,
      viewCheck: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onCloseAction = this.onCloseAction.bind(this);
    this.handleDisposition = this.handleDisposition.bind(this);
    this.onItemDisposition = this.onItemDisposition.bind(this);
  }

  componentDidMount() {
    fetch("on_check_Locked_item", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ page: 0 });
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ viewCheck: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ selectedItemIndex: -1 });
  }

  onCloseAction(e) {
    this.setState({ action: 0 });
  }

  onItemDisposition(e) {
    let newItems = this.state.items;
    newItems.splice(this.state.selectedItemIndex, 1);
    // reorder the indexes
    for (let i = 0; i < newItems.length; i++) {
      newItems[i].index = i;
    }
    this.setState({ items: newItems });
    let totCount = this.state.totalCount - 1;
    this.setState({ selectedItemIndex: -1 });
    this.setState({ totalCount: totCount });
  }

  handleDisposition(e, dispAction) {
    this.setState({ confirmDisposition: false });
    // confirmed
    if (dispAction === 1) {
      let actionUrl =
        this.state.action === 2
          ? "on_ccprint_approve"
          : "on_ccprint_print_or_void";
      fetch(actionUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.props.accountObject.transit,
          account: this.props.accountObject.account,
          rangeId: this.props.accountObject.rangeId,
          approve: this.state.acceptDisposition,
          requestId: this.state.selectedItem.requestId,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            if (reply.warning) {
              this.setState({ notifyString: reply.warningString });
              this.setState({ viewPopup: true });
            } else {
              if (this.state.action === 2) {
                this.setState({ notifyString: "The decision has been saved." });
                this.setState({ viewPopup: true });
              } else {
                if (this.state.acceptDisposition) {
                  // embedded fonts are not supported in Chrome and Firefox pdf viewer - fix the pdf maybe???
                  var ua = window.navigator.userAgent;
                  var msie = ua.indexOf("MSIE ");
                  //var edge = ua.indexOf('Edge/');
                  //if (msie > 0 || edge > 0) {
                  if (msie > 0) {
                    this.setState({ viewCheck: true });
                  } else {
                    fetch(
                      "on_fetch_pdf_report?report_id=" +
                        new Date().getTime() +
                        "&secureToken=" +
                        this.props.secureToken
                    ).then((response) => {
                      response.blob().then((blob) => {
                        var url = window.URL.createObjectURL(blob, { oneTimeOnly: true });
                        window.open(url,'','height=1200,width=900,left=400,top=50');
                      });
                    });
                  }
                } else {
                  this.setState({ notifyString: "The check has been voided." });
                  this.setState({ viewPopup: true });
                }
              }
            }
            this.onItemDisposition();
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
          this.setState({ viewPopup: true });
        });
    }
  }

  handleApprove(e, itemIndex, approve) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    let myItems = this.state.items;
    this.setState({ selectedItemIndex: itemIndex });
    this.setState({ selectedItem: myItems[itemIndex] });
    this.setState({ acceptDisposition: approve });
    this.setState({ confirmDisposition: true });
  }

  handleActions(event, selectedAction) {
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
    this.setState({ orderBy: "" });
    this.setState({ action: selectedAction });
    this.setState({ selectedItemIndex: -1 });
    if (selectedAction === 2) {
      this.searchPendingApproved("on_search_ccprint_pending");
    } else if (selectedAction === 3) {
      this.searchPendingApproved("on_search_ccprint_approved");
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
    if (this.state.canSearch) {
      this.search(this.getCriteriaObject(page, this.state.rowsPerPage), true);
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
    window.sco_large_items_per_page = event.target.value;
    if (this.state.canSearch) {
      this.search(
        this.getCriteriaObject(this.state.page, event.target.value),
        true
      );
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.items);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (
        orderBy === "requestId" ||
        orderBy === "checkNumber" ||
        orderBy === "checkNumber"
      ) {
        data.sort(getNumberSorting(order, orderBy));
      } else if (orderBy === "amount") {
        data.sort(getFloatSorting(order, "rowAmount"));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      this.setState({ items: data });
    }
  }

  handleCollapse = (event) => {
    this.setState({ collapsedSearch: !this.state.collapsedSearch });
  };

  handleStartDate(date) {
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleCheckFrom(e) {
    this.disableSearch();
    this.setState({ checkFrom: e.target.value });
  }

  handleCheckTo(e) {
    this.disableSearch();
    this.setState({ checkTo: e.target.value });
  }

  handleAmountFrom(e) {
    this.disableSearch();
    this.setState({ amountFrom: e.target.value });
  }

  handleAmountTo(e) {
    this.disableSearch();
    this.setState({ amountTo: e.target.value });
  }

  handleReportTypeChange(e) {
    this.disableSearch();
    this.setState({ reportType: e.target.value });
  }

  handleRadioChange = (event) => {
    this.setState({ radioValue: event.target.value });
  };

  handleReportStatusChange(e) {
    this.disableSearch();
    this.setState({ reportStatus: e.target.value });
  }

  handlePdf(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  handleSearch(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ page: 0 });
    this.setState({ orderBy: "" });
    this.setState({ canSearch: true });
    this.search(this.getCriteriaObject(0, this.state.rowsPerPage), false);
  }

  validateDates() {
    let start = this.state.startDate;
    let end = this.state.endDate;
    if (start !== null && end !== null && end.isBefore(start, "day")) {
      this.setState({
        errorString: getErrorString(
          "general.error.endDate",
          "End Date is before Start Date"
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  search(searchData, sortIt) {
    fetch("on_search_ccprint_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(searchData),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ reply: reply });
          let newItems = reply.items;
          this.setState({ items: newItems });
          this.setState({ totalCount: reply.totalCount });
          if (sortIt) {
            this.sort(this.state.orderBy, this.state.order, newItems);
          }
          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  searchPendingApproved(requestUrl) {
    fetch(requestUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        rangeId: this.props.accountObject.rangeId,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ items: reply.items });
          this.setState({ totalCount: reply.totalCount });
          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }
  getCriteriaObject(myPage, myRowsPerPage) {
    let data = {
      transit: this.props.accountObject.transit,
      account: this.props.accountObject.account,
      page: myPage,
      rowsPerPage: myRowsPerPage,
      reportType: this.state.reportType,
      startDate: this.state.backendStartDate,
      endDate: this.state.backendEndDate,
      reportStatus: this.state.reportStatus,
      reportGroup: this.state.radioValue,
      checkFrom: this.state.checkFrom,
      checkTo: this.state.checkTo,
      amountFrom: this.state.amountFrom,
      amountTo: this.state.amountTo,
      secureToken: this.props.secureToken,
    };
    return data;
  }

  render() {
    const { classes } = this.props;
    const { order, orderBy, rowsPerPage, page } = this.state;
    let data = this.state.items;
    let totalCount = this.state.totalCount;
    let { t } = this.props;
    return (
      <div id="myTopDiv">
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            page={page}
            rowsPerPage={rowsPerPage}
            postData={this.getCriteriaObject(page, rowsPerPage)}
            pdfUrl="on_search_ccprint_pdf_request"
          />
        )}

        {this.state.viewCheck && (
          <ViewCCCheck
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.action === 2 && this.state.confirmDisposition && (
          <ConfirmDialog
            title={
              this.state.acceptDisposition
                ? t("confirmApproveAction.label")
                : t("confirmRejectAction.label")
            }
            text={
              this.state.acceptDisposition
                ? t("approveRequst.label") +
                  this.state.selectedItem.requestId +
                  " ?"
                : t("rejectRequst.label") +
                  this.state.selectedItem.requestId +
                  " ?"
            }
            onCloseConfirm={this.handleDisposition}
          />
        )}
        {this.state.action === 3 && this.state.confirmDisposition && (
          <ConfirmDialog
            title={
              this.state.acceptDisposition
                ? t("confirmPrintAction.label")
                : t("confirmVoidAction.label")
            }
            text={
              this.state.acceptDisposition
                ? t("printRequst.label")
                : t("voidRequst.label") +
                  this.state.selectedItem.requestId +
                  " ?"
            }
            onCloseConfirm={this.handleDisposition}
          />
        )}

        <div className={classes.toolbar}>
          <FormGroup row className={classes.vCenterItems}>
            <Typography variant="h6" color="primary">
              &nbsp;&nbsp; {t("cashierChecks.label")}
              &nbsp;&nbsp;
            </Typography>
            {this.props.accountObject.cashierChecksReport && (
              <Tooltip title={t("viewCashierCheck.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 1)}
                    disabled={this.state.action === 1}
                  >
                    <HistoryIcon />
                    &nbsp;{t("history.button")}
                  </Button>
                </div>
              </Tooltip>
            )}
            {this.props.accountObject.cashierChecksApprove && (
              <Tooltip title={t("approveCashierCheck.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 2)}
                    disabled={this.state.action === 2}
                  >
                    <ApproveIcon />
                    &nbsp;{t("approve.button")}
                  </Button>
                </div>
              </Tooltip>
            )}
            {this.props.accountObject.cashierChecksPrint && (
              <Tooltip title={t("printCashierCheck.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 3)}
                    disabled={this.state.action === 3}
                  >
                    <PrintIcon />
                    &nbsp;{t("print.label")}
                  </Button>
                </div>
              </Tooltip>
            )}
            {this.props.accountObject.cashierChecksRequest && (
              <Tooltip title={t("requestCashierCheck.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 4)}
                    disabled={this.state.action === 4}
                  >
                    <CCAddIcon />
                    &nbsp;{t("request.button")}
                  </Button>
                </div>
              </Tooltip>
            )}
          </FormGroup>
          <Divider />
        </div>
        <div className={classes.tableWrapper}>
          {this.state.action === 4 && (
            <CCRequest
              history={this.props.history}
              secureToken={this.props.secureToken}
              viewOnly={this.props.viewOnly}
              accountObject={this.props.accountObject}
              onClose={this.onCloseAction}
            />
          )}

          {this.state.action === 1 && (
            <div>
              
                <FormGroup row>
                  <TextField
                    margin="dense"
                    id="checkFrom"
                    label={t("checkNoFrom.label")}
                    type="text"
                    defaultValue={this.state.checkFrom}
                    onChange={(event) => this.handleCheckFrom(event)}
                    onKeyPress={(event) => {
                      return event.charCode >= 48 && event.charCode <= 57
                        ? true
                        : event.preventDefault();
                    }}
                  />
                  &nbsp;&nbsp;
                  <TextField
                    margin="dense"
                    id="checkTo"
                    label={t("checkNoTo.label")}
                    type="text"
                    defaultValue={this.state.checkTo}
                    onChange={(event) => this.handleCheckTo(event)}
                    onKeyPress={(event) => {
                      return event.charCode >= 48 && event.charCode <= 57
                        ? true
                        : event.preventDefault();
                    }}
                  />
                  &nbsp;&nbsp;
                  <TextField
                    margin="dense"
                    id="amountFrom"
                    label={t("amountFrom.label")}
                    type="text"
                    defaultValue={this.state.amountFrom}
                    onChange={(event) => this.handleAmountFrom(event)}
                    InputProps={{
                      inputComponent: AmountFormatCustom,
                    }}
                  />
                  &nbsp;&nbsp;
                  <TextField
                    margin="dense"
                    id="amountTo"
                    label={t("amountTo.label")}
                    type="text"
                    defaultValue={this.state.amountTo}
                    onChange={(event) => this.handleAmountTo(event)}
                    InputProps={{
                      inputComponent: AmountFormatCustom,
                    }}
                  />
                  &nbsp;&nbsp;
				<div style={{ marginTop: 20 }}> 
                  <Tooltip title={t("searchCashierCheck.tip")}>
                    <Button
                      color="primary"
                      onClick={(event) => this.handleSearch(event)}
                    >
                      <SearchIcon />
                      &nbsp;{t("search.button")}
                    </Button>
                  </Tooltip>
				</div> 
                  &nbsp;&nbsp;
				<div style={{ marginTop: 20 }}> 
                  <Tooltip title={t("viewPdfReport.tip")}>
                    <Button
                      color="primary"
                      onClick={(event) => this.handlePdf(event)}
                    >
                      <PDFViewIcon />
                      &nbsp;{t("pdf.button")}
                    </Button>
                  </Tooltip>
				</div> 
                </FormGroup>
				<div style={{ height: 20 }}> 
				</div> 
                <FormGroup row>
                
                  <Typography variant="caption" style={{ paddingTop: 10 }}>
                    {t("reportStatus.label")}&nbsp;&nbsp;&nbsp;&nbsp;
                  </Typography>
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 27,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.state.reportStatus}
                      input={<Input id="report_status" />}
                      onChange={(event) => this.handleReportStatusChange(event)}
                    >
                      <option value="10">{t("any.label")}</option>
                      <option value="0">{t("requestInit.label")}</option>
                      <option value="1">{t("compApproved.label")}</option>
                      <option value="2">{t("bankApproved1.label")}</option>
                      <option value="3">{t("bankApproved2.label")}</option>
                      <option value="4">{t("checkImagePending.label")}</option>
                      <option value="5">{t("readyPrinting.label")}</option>
                      <option value="6">{t("checkPrinted.label")}</option>
                      <option value="7">{t("checkVoided.label")}</option>
                      <option value="8">{t("checkRejected.label")}</option>
                      <option value="9">{t("error.label")}</option>
                    </NativeSelect>
                  </FormControl>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Typography variant="caption" style={{ marginTop: 10 }}>
                    {t("reportDateType.label")}&nbsp;&nbsp;&nbsp;&nbsp;
                  </Typography>
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 27,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.state.reportType}
                      input={<Input id="report_type" />}
                      onChange={(event) => this.handleReportTypeChange(event)}
                    >
                      <option value="request">{t("request.label")}</option>
                      <option value="compappr">{t("compApprove.label")}</option>
                      <option value="bankappr">{t("bankApprove.label")}</option>
                      <option value="print">{t("print.label")}</option>
                      <option value="void">{t("void.label")}</option>
                    </NativeSelect>
                  </FormControl>
                  &nbsp;&nbsp;
                
				  <div style={{ marginTop: 10 }}> 
                  <Typography variant="caption">
                    {t("startDate.label")}&nbsp;&nbsp;
                    {!this.state.redrawStartDate && (
                      <DatePicker
                        isClearable
                        disabledKeyboardNavigation
                        dateFormat="LL"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={this.state.startDate}
                        onChange={(event) => this.handleStartDate(event)}
                        onClickOutside={(event) =>
                          this.handleStartDateOutsideClick(event)
                        }
                        popperContainer={CalendarContainer}
                      />
                    )}
                  </Typography>
				  </div> 
                  &nbsp;&nbsp;
				  <div style={{ marginTop: 10 }}> 
                  <Typography variant="caption">
                    {t("endDate.label")}&nbsp;&nbsp;
                    {!this.state.redrawEndDate && (
                      <DatePicker
                        isClearable
                        disabledKeyboardNavigation
                        dateFormat="LL"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={this.state.endDate}
                        onChange={(event) => this.handleEndDate(event)}
                        onClickOutside={(event) =>
                          this.handleEndDateOutsideClick(event)
                        }
                        popperContainer={CalendarContainer}
                      />
                    )}
                  </Typography>
				  </div> 
                </FormGroup>
				<div style={{ height: 20 }}> 
				</div> 
                <FormGroup row>
				  <div style={{ marginTop: 10 }}> 
                  <Typography variant="caption">
                    {t("reportGrouped.label")}&nbsp;&nbsp;&nbsp;&nbsp;
                  </Typography>
				  </div> 
				  
                  <FormControlLabel
                    value="date"
                    control={
                      <Radio
                        color="default"
                        checked={this.state.radioValue === "date"}
                        onChange={this.handleRadioChange}
                        value="date"
                        name="radioButton"
                      />
                    }
                    label={t("reportDate.label")}
                  />
                  <FormControlLabel
                    value="status"
                    control={
                      <Radio
                        color="default"
                        checked={this.state.radioValue === "status"}
                        onChange={this.handleRadioChange}
                        value="status"
                        name="radioButton"
                      />
                    }
                    label={t("reportStatus.label")}
                  />
                </FormGroup>
              

              <TablePagination
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={CustomPaginatorActions}
              />
              {this.state.canSearch && this.state.totalCount > 0 && (
                <Paper>
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <CustomTableHead
                      order={order}
                      orderBy={orderBy}
                      columnData={columnData}
                      onRequestSort={this.handleRequestSort}
                    />
                    <TableBody>
                      {data.map((n) => {
                        return (
                          <TableRow key={n.index}>
                            <TableCell>{n.date}</TableCell>
                            <TableCell>{n.requestor}</TableCell>
                            <TableCell>{n.requestId}</TableCell>
                            <TableCell>{n.checkNumber}</TableCell>
                            <TableCell>{n.amount}</TableCell>
                            <TableCell
                              style={{
                                width: "40%",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}
                            >
                              {n.payable}
                            </TableCell>
                            <TableCell>{t(n.status)}</TableCell>
                            <TableCell>{n.voidInd}</TableCell>
                            <TableCell>{n.custCount}</TableCell>
                            <Tooltip
                              title={
                                <div>
                                  {t("printDate.tip")}: {n.printDate} <br />
                                  {t("printedBy.tip")}: {n.printedBy} <br />
                                  {t("compApproveDate.tip")}:{" "}
                                  {n.compApproveDate} <br />
                                  {t("compApproveBy.tip")}: {n.compApprovedBy}{" "}
                                  <br />
                                  {t("bankApproveDate.tip")}:{" "}
                                  {n.bankApproveDate} <br />
                                  {t("bankApproveBy.tip")}: {n.bankApprovedBy}{" "}
                                  <br />
                                  {t("voidDate.tip")}: {n.voidRequestDate}{" "}
                                  <br />
                                  {t("voidBy.tip")}: {n.voidRequestBy}
                                </div>
                              }
                            >
                              <TableCell>
                                <InfoIcon color="primary" />
                              </TableCell>
                            </Tooltip>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                    {this.state.totalCount > 0 &&
                      (page + 1) * rowsPerPage >= this.state.totalCount && (
                        <TableFooter className={classes.boldCell}>
                          <TableRow>
                            <TableCell className={classes.boldCell} colSpan={4}>
                              {t("totalAmount.label")}:{" "}
                              {this.state.reply.totalAmount}
                            </TableCell>
                          </TableRow>
                        </TableFooter>
                      )}
                  </Table>
                </Paper>
              )}
            </div>
          )}

          {(this.state.action === 2 || this.state.action === 3) &&
            this.state.totalCount > 0 && (
              <div>
                <div>
                  <Paper>
                    <Typography variant="h6">
                      {this.state.action === 2
                        ? t("printRequestPending.label")
                        : t("checksReady.label")}
                    </Typography>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                    >
                      <TableHead>
                        <TableRow>
                          {columnData2.map((column) => {
                            return (
                              <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={
                                  column.disablePadding ? "none" : "default"
                                }
                              >
                                {column.label}
                              </TableCell>
                            );
                          }, this)}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((n) => {
                          return (
                            <TableRow key={n.index}>
                              <TableCell>{n.requestId}</TableCell>
                              <TableCell>{n.serial}</TableCell>
                              <TableCell>{n.amount}</TableCell>
                              <TableCell
                                style={{
                                  width: "40%",
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {n.payable}
                              </TableCell>
                              <TableCell>
                                <Button
                                  size="small"
                                  color="primary"
                                  style={{
                                    margin: 0,
                                    padding: 0,
                                    minWidth: 0,
                                    minHeight: 0,
                                  }}
                                  onClick={(event) =>
                                    this.handleApprove(event, n.index, true)
                                  }
                                >
                                  {this.state.action === 2
                                    ? t("approve.button")
                                    : t("print.label")}
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  size="small"
                                  color="primary"
                                  style={{
                                    margin: 0,
                                    padding: 0,
                                    minWidth: 0,
                                    minHeight: 0,
                                  }}
                                  onClick={(event) =>
                                    this.handleApprove(event, n.index, false)
                                  }
                                >
                                  {this.state.action === 2
                                    ? t("reject.button")
                                    : t("void.label")}
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Paper>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

ManageCCPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(ManageCCPage));
